import { render } from "./RestaurantRidersView.vue?vue&type=template&id=4795c05e&scoped=true"
import script from "./RestaurantRidersView.vue?vue&type=script&lang=js"
export * from "./RestaurantRidersView.vue?vue&type=script&lang=js"

import "./RestaurantRidersView.vue?vue&type=style&index=0&id=4795c05e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4795c05e"]])

export default __exports__